import { render } from "./modalButton.vue?vue&type=template&id=58b4ab16&scoped=true"
import script from "./modalButton.vue?vue&type=script&lang=js"
export * from "./modalButton.vue?vue&type=script&lang=js"

import "./modalButton.vue?vue&type=style&index=0&id=58b4ab16&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-58b4ab16"

export default script